var exports = {
  "container": "x9bf38834--bdfbd8--container",
  "image": "x9bf38834--bdfbd8--image",
  "applied": "x9bf38834--bdfbd8--applied",
  "canceled": "x9bf38834--bdfbd8--canceled",
  "error": "x9bf38834--bdfbd8--error",
  "title": "x9bf38834--bdfbd8--title",
  "description": "x9bf38834--bdfbd8--description",
  "btn": "x9bf38834--bdfbd8--btn",
};

module.exports = exports;
